import React from 'react';
import loadingSpin from '../assert/loadingspinner@3x.png'
import '../style/loadingOverlay.less';

export default function LoadingOverlay({loading = true}) {
  return <div className={loading ? "loading-wrapper loading": "loading-wrapper"}>
    <div className="mask"/>
    <img className="spinner" src={loadingSpin} alt="loading"/>
  </div>
}